export default __webpack_public_path__ + "static/media/person-shadow.5033e1a7.svg";